/** Charte graphique Safecheck RDC */
export const brand = {
  lime: "#B8E417",
  navy: "#284380",
  white: "#FFFFFF",
  black: "#000000",
  navyLight: "#4a6baa",
  navyDark: "#1a2f55",
  limeDark: "#9bc420",
} as const;

/** Couleurs graphiques adaptées au mode sombre */
export const brandDark = {
  lime: "#B8E417",
  navy: "#6b9fd4",
  navyLight: "#8fb4e0",
  navyDark: "#4a7ab8",
  limeDark: "#c8e840",
} as const;

export const chartPalette = [
  brand.navy,
  brand.lime,
  brand.navyLight,
  brand.limeDark,
  brand.navyDark,
] as const;

export const chartPaletteDark = [
  brandDark.navy,
  brandDark.lime,
  brandDark.navyLight,
  brandDark.limeDark,
  brandDark.navyDark,
] as const;
